export const userColumns = [
	{ field: "id", headerName: "ID", width: 70 },
	{
		field: "username",
		headerName: "Username",
		width: 150,
		renderCell: (params) => {
			return (
				<div className="flex items-center">
					<img
						className="h-8 w-8 rounded-full mr-3"
						src={params.row.img}
						alt="avatar"
					/>
					{params.row.username}
				</div>
			);
		},
	},
	{
		field: "email",
		headerName: "Email",
		width: 150,
	},

	{
		field: "firstname",
		headerName: "First Name",
		width: 100,
	},
	{
		field: "middlename",
		headerName: "Middle Name",
		width: 100,
	},
	{
		field: "lastname",
		headerName: "Last Name",
		width: 100,
	},
	{
		field: "dateofbirth",
		headerName: "Date of Birth",
		width: 100,
	},
	{
		field: "secondaryschool",
		headerName: "Secondary School",
		width: 100,
	},
	{
		field: "county",
		headerName: "County",
		width: 100,
	},
	{
		field: "datejoined",
		headerName: "Date Joined",
		width: 100,
	},
];

//temporary data
export const userRows = [
	{
		id: 1,
		username: "Snow",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "1snow@gmail.com",
		firstname: "Jony",
		middlename: "Depp",
		lastname: "atkins",
		dateofbirth: "04/22/1999",
		secondaryschool: "Mangu School",
		county: "Meru",
		datejoined: "04/21/2022",
	},
	{
		id: 2,
		username: "Jamie Lannister",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "2snow@gmail.com",
		firstname: "Jamie",
		middlename: "Lannister",
		lastname: "Maguire",
		dateofbirth: "02/14/2001",
		secondaryschool: "St Francis Mangu",
		county: "Nyeri",
		datejoined: "04/21/2022",
	},
	{
		id: 3,
		username: "Lannister",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "3snow@gmail.com",
		firstname: "Annie",
		middlename: "Holding",
		lastname: "Cooper",
		dateofbirth: "12/15/2002",
		secondaryschool: "Loreto Limuru",
		county: "Mombasa",
		datejoined: "04/21/2022",
	},
	{
		id: 4,
		username: "Stark",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "4snow@gmail.com",
		firstname: "Betty",
		middlename: "Holman",
		lastname: "Stark",
		dateofbirth: "10/12/2000",
		secondaryschool: "Bishop Gatimu",
		county: "Muranga",
		datejoined: "04/21/2022",
	},
	{
		id: 5,
		username: "Targaryen",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "5snow@gmail.com",
		firstname: "Alisha",
		middlename: "Targaryen",
		lastname: "Bennings",
		dateofbirth: "04/09/2001",
		secondaryschool: "Kenya High",
		county: "Nairobi",
		datejoined: "04/21/2022",
	},
	{
		id: 6,
		username: "Melisandre",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "6snow@gmail.com",
		firstname: "David",
		middlename: "Melisandre",
		lastname: "Alvares",
		dateofbirth: "05/17/2004",
		secondaryschool: "Nyeri High",
		county: "Machakos",
		datejoined: "04/21/2022",
	},
	{
		id: 7,
		username: "Clifford",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "7snow@gmail.com",
		firstname: "Mason",
		middlename: "Clifford",
		lastname: "Keen",
		dateofbirth: "11/28/2005",
		secondaryschool: "Chavakali",
		county: "Siaya",
		datejoined: "04/21/2022",
	},
	{
		id: 8,
		username: "Frances",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "8snow@gmail.com",
		firstname: "Danny",
		middlename: "Frances",
		lastname: "Ramsdale",
		dateofbirth: "04/03/2005",
		secondaryschool: "Muranga High",
		county: "Kitui",
		datejoined: "04/21/2022",
	},
	{
		id: 9,
		username: "cdrinkwater",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "snow@gmail.com",
		firstname: "Cain",
		middlename: "Drinkwater",
		lastname: "Rice",
		dateofbirth: "06/30/2004",
		secondaryschool: "Alliance Boys",
		county: "Embu",
		datejoined: "04/21/2022",
	},
	{
		id: 10,
		username: "Roxie",
		img: "https://images.pexels.com/photos/1820770/pexels-photo-1820770.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		email: "snow@gmail.com",
		firstname: "Liz",
		middlename: "Roxie",
		lastname: "Blind",
		dateofbirth: "08/01/2005",
		secondaryschool: "Mary Hills",
		county: "Kiambu",
		datejoined: "04/21/2022",
	},
];
